import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function NavigationTracker() {
    const location = useLocation();

    useEffect(() => {
        // Navigation tracking placeholder (base44 logging removed)
    }, [location]);

    return null;
}